<ng-lottie
  containerClass="moving-box"
  [options]="options"
  [styles]="styles"
></ng-lottie>

<!-- height="500px" -->
